<script lang="ts">
  import SupportHeader from './SupportHeader.svelte';
  import SupportChat from './SupportChat.svelte';
  import VisitorForm from './VisitorForm.svelte';
  import ConfirmationModal from './ConfirmationModal.svelte';
  import EditProfile from './EditProfile.svelte';
  import Footer from './Footer.svelte';
  import { appState } from '../state.svelte';
  import { t } from '../i18n/index';

  let {
    hasVisitor,
    visitorId = '',
    pendingAuth = false,
    authError = '',
    onMinimize,
    onVisitorFormSubmit,
    onSendMessage,
    onUpload,
    onClearConfirmed,
    onEditProfileSave,
  }: {
    hasVisitor: boolean;
    visitorId?: string;
    pendingAuth?: boolean;
    authError?: string;
    onMinimize: () => void;
    onVisitorFormSubmit: (p: { name: string; email: string | null }) => void;
    onSendMessage: (text: string) => void;
    onUpload?: (files: File[]) => void;
    onClearConfirmed: () => void;
    onEditProfileSave: (p: { name: string; email: string | null }) => void;
  } = $props();

  let showClearConfirm = $state(false);
  let showEditProfile = $state(false);

  const frameClasses = $derived.by(() => {
    if (appState.isMobile) {
      return 'tashimoto-support-fixed tashimoto-support-inset-0 tashimoto-support-w-full tashimoto-support-h-full tashimoto-support-bg-white tashimoto-support-flex tashimoto-support-flex-col';
    }
    return 'tashimoto-support-fixed tashimoto-support-bottom-6 tashimoto-support-right-6 tashimoto-support-w-[380px] tashimoto-support-h-[75vh] tashimoto-support-bg-white tashimoto-support-rounded-xl tashimoto-support-shadow-2xl tashimoto-support-overflow-hidden tashimoto-support-flex tashimoto-support-flex-col tashimoto-support-border tashimoto-support-border-gray-200';
  });

  // Lock body scroll while mobile full-viewport is mounted.
  $effect(() => {
    if (!appState.isMobile) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  });
</script>

<div
  class={frameClasses}
  style="z-index: {appState.zIndex};"
  data-testid="support-frame"
  data-mobile={appState.isMobile ? '1' : '0'}
>
  <SupportHeader
    onMinimize={onMinimize}
    onEditProfile={() => {
      showEditProfile = true;
    }}
    onClear={() => {
      showClearConfirm = true;
    }}
  />

  {#if !hasVisitor}
    <div class="tashimoto-support-flex-1 tashimoto-support-overflow-y-auto">
      <VisitorForm
        onSubmit={onVisitorFormSubmit}
        pending={pendingAuth}
        errorMessage={authError}
      />
    </div>
  {:else}
    <SupportChat
      visitorId={visitorId}
      onSend={onSendMessage}
      onUpload={onUpload}
    />
    <Footer />
  {/if}

  {#if showClearConfirm}
    <ConfirmationModal
      title={t('clear.title')}
      message={t('clear.message')}
      onConfirm={() => {
        showClearConfirm = false;
        onClearConfirmed();
      }}
      onCancel={() => {
        showClearConfirm = false;
      }}
    />
  {/if}

  {#if showEditProfile}
    <EditProfile
      onSave={(p) => {
        showEditProfile = false;
        onEditProfileSave(p);
      }}
      onCancel={() => {
        showEditProfile = false;
      }}
    />
  {/if}
</div>
